import _objectSpread from "/builds/huggg/mono/node_modules/.pnpm/@babel+runtime@7.9.0/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import { path, prop, propOr } from 'ramda';
import { urls } from '../../config.js';
import { firstById, mapById } from '../../utils/find';
import getParams from '../../utils/getParams';
import withAxios from '../../utils/with-axios';
import voucher from './../voucher.js';
import allBySuperhugggId from './allBySuperhugggId';
import allByTransactionId from './allByTransactionId';
import update from './update';
import toggleSent from './toggleSent';

/* Variable Declaration
========================================================================== */
var DEFAULT_EMBED = ['purchase.brand.integration', 'purchase.brand.stores', 'purchase.segments', 'message', 'sender', 'receiver', 'voucher.segment', 'redeemed'];
var EPOS_INTEGRATIONS = [5, 6]; // eslint-disable-line no-magic-numbers
var BARCODE_INTEGRATION = 6; // eslint-disable-line no-magic-numbers

/* Utilities
========================================================================== */
var reformatOldVouchers = function reformatOldVouchers(huggg) {
  var integrationId = path(['purchase', 'brand', 'integration_id'], huggg);
  var vouchers = huggg.voucher ? voucher.reformatSegmentVoucher(huggg.voucher, huggg.segment) : [];
  if (EPOS_INTEGRATIONS.includes(integrationId) && huggg.redeem_code) {
    vouchers.push({
      label: '',
      value: "HUGGG".concat(huggg.redeem_code),
      type: integrationId === BARCODE_INTEGRATION ? 'barcode' : 'qr'
    });
    vouchers.push({
      label: '',
      value: huggg.redeem_code,
      type: integrationId === BARCODE_INTEGRATION ? 'alpha/barcode' : 'alpha/qr'
    });
  }
  return _objectSpread(_objectSpread({}, huggg), {}, {
    vouchers: vouchers
  });
};
var reformatHuggg = function reformatHuggg(_ref) {
  var huggg = _ref.data,
    embedded = _ref.embedded;
  var extract = function extract(id) {
    return propOr([], id, embedded);
  };
  var purchase = firstById(extract('products'), prop('purchase_id', huggg));
  var message = firstById(extract('messages'), prop('message_id', huggg));
  var sender = firstById(extract('users'), prop('sender_id', huggg));
  var receiver = firstById(extract('users'), prop('receiver_id', huggg));
  var voucher = firstById(extract('vouchers'), prop('voucher_id', huggg));
  var redeemed = firstById(extract('redemptions'), prop('redeemed_id', huggg));
  var segment = firstById(extract('product_segments'), prop('segment_id', voucher));
  if (purchase) {
    purchase.segments = mapById(extract('product_segments'), propOr([], 'segments', purchase));
    purchase.brand = firstById(extract('brands'), prop('brand_id', purchase));
    if (purchase.brand) {
      purchase.brand.integration = firstById(extract('integrations'), prop('integration_id', purchase.brand));
      purchase.brand.locations = extract('stores');
    }
  }
  return _objectSpread(_objectSpread({}, huggg), {}, {
    purchase: purchase,
    message: message,
    sender: sender,
    receiver: receiver,
    redeemed: redeemed,
    segment: segment,
    voucher: voucher
  });
};

/* Exported Methods
========================================================================== */
var fetch = function fetch(axios) {
  var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    _ref2$page = _ref2.page,
    page = _ref2$page === void 0 ? 1 : _ref2$page,
    _ref2$perPage = _ref2.perPage,
    perPage = _ref2$perPage === void 0 ? null : _ref2$perPage;
  var embed = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : ['purchase.brand', 'sender'];
  var params = {
    embed: embed,
    platform: 'app',
    page: page
  };
  if (perPage) {
    params.per_page = perPage;
  }
  return axios.get(urls.apiV2('/hugggs/available'), {
    params: params
  }).then(prop('data')).then(function (data) {
    var hugggs = data.data;
    var embedded = data.embedded;
    return hugggs.map(function (item) {
      return reformatHuggg({
        data: item,
        embedded: embedded
      });
    });
  });
};

/**
 *
 * @param {Object} [axios=$axios] Axios instance.
 * @param {String} id Huggg ID
 * @param {Object} [options={}] Options to supply the endpoint.
 * @param {Array} [options[].embed=DEFAULT_EMBED]
 *    Which embedded data should be returned.
 *    Supported embeds: [
 *      'purchase.brand.integration',
 *      'purchase.brand.stores',
 *      'purchase.segments',
 *      'message',
 *      'sender',
 *      'receiver',
 *      'voucher.segment',
 *      'redeemed'
 *    ]
 * @param {Boolean} [options.isPreview=false]
 *    Alert the endpoint that this huggg has been viewed as a preview, and to
 *    not mark it as being "viewed" by a recipient.
 */
function single(axios, id) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var defaultParams = {
    embed: DEFAULT_EMBED,
    is_preview: false
  };
  var params = getParams(options, defaultParams);
  return axios.get(urls.apiV2("/hugggs/".concat(id)), {
    params: _objectSpread(_objectSpread({}, params), {}, {
      platform: 'app'
    })
  }).then(prop('data')).then(reformatHuggg).then(reformatOldVouchers).then(function (huggg) {
    return voucher.fetchVoucherV2Details(axios, huggg, false);
  });
}

/**
 *
 * @param {Object} [axios=$axios] Axios instance.
 * @param {String} id Huggg ID
 * @param {Object} [options={}] Options to supply the endpoint.
 * @param {Array} [options[].embed=DEFAULT_EMBED]
 *    Which embedded data should be returned.
 *    Supported embeds: [
 *      'purchase.brand.integration',
 *      'purchase.brand.stores',
 *      'purchase.segments',
 *      'message',
 *      'sender',
 *      'receiver',
 *      'voucher.segment',
 *      'redeemed'
 *    ]
 * @param {Boolean} [options.isPreview=false]
 *    Alert the endpoint that this huggg has been viewed as a preview, and to
 *    not mark it as being "viewed" by a recipient.
 */
function testHuggg(axios, id) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var defaultParams = {
    embed: DEFAULT_EMBED,
    is_preview: false
  };
  var params = getParams(options, defaultParams);
  return axios.get(urls.apiV2("/test-hugggs/".concat(id)), {
    params: _objectSpread(_objectSpread({}, params), {}, {
      platform: 'app'
    })
  }).then(prop('data')).then(reformatHuggg).then(reformatOldVouchers).then(function (huggg) {
    return voucher.fetchVoucherV2Details(axios, huggg, true);
  });
}

/**
 *
 * @param {Object} [axios=$axios] Axios instance.
 * @param {String} id Huggg ID
 * @param {Object} [payload={}] Payload to supply the endpoint.
 * @param {String} payload.message The message for the huggg
 * @param {String} payload.productId The product Id for the huggg
 * @param {String} payload.expiry The expiry date for the huggg
 * @param {String} payload.themeId The theme ID for the huggg
 */
function createTestHuggg(axios) {
  var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return axios.post(urls.apiV2("/test-hugggs"), payload).then(prop('data')).then(reformatHuggg).then(reformatOldVouchers).then(function (huggg) {
    return voucher.fetchVoucherV2Details(axios, huggg, true);
  });
}

/**
 *
 * @param {Object} [axios=$axios] Axios instance.
 * @param {String} id Huggg ID
 * @param {Object} [payload={}] Payload to supply the endpoint.
 * @param {String} payload.message The message for the huggg
 * @param {String} payload.productId The product Id for the huggg
 * @param {String} payload.expiry The expiry date for the huggg
 * @param {String} payload.themeId The theme ID for the huggg
 */
function updateTestHuggg(axios, id) {
  var payload = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return axios.put(urls.apiV2("/test-hugggs/".concat(id)), payload).then(prop('data')).then(reformatHuggg).then(reformatOldVouchers).then(function (huggg) {
    return voucher.fetchVoucherV2Details(axios, huggg, true);
  });
}

/**
 *
 * @param {Object} [axios=$axios] Axios instance.
 * @param {String} id Huggg ID
 * @param {Object} [receivers=[]] Payload to supply the endpoint.
 * @param {String} receivers.phone_number The receivers phone number
 * @param {String} receivers.email The receivers email
 */
function sendTestHuggg(axios, id) {
  var payload = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return axios.post(urls.apiV2("/test-hugggs/".concat(id, "/send")), payload).then(prop('data'));
}
var stash = function stash(axios, shortcode) {
  var phoneNumber = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  var allowSelfClaim = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  return axios.put(urls.apiV2("/hugggs/".concat(shortcode, "/receiver")), {
    phone_number: phoneNumber,
    allow_self_claim: allowSelfClaim
  }).then(prop('data'));
};
var redeem = function redeem(axios, id, code) {
  return axios.post(urls.apiV2('/redeem'), {
    hug_id: id,
    code: code
  }).then(path(['data', 'redemption']));
};
var cancel = function cancel(axios, id) {
  return axios.post(urls.apiV2("/hugggs/".concat(id, "/cancel"))).then(path(['data']));
};

/**
 *
 * @param {Object} [axios=axios] Axios instance.
 *  * @param {Object} order The details of your order as  outlined at
 * https://docs.huggg.me/endpoints/transactions/. Must contain payment and
 * purchase keys in order to be a satisfiable purchase order.
 */
var bulkOrder = function bulkOrder(axios, order) {
  return axios.post(urls.apiV2("/transactions"), order).then(prop('data'));
};

/**
 * Sends a QR code for a Huggg to a recipient's email.
 *
 * @param {Object} [axios=$axios] Axios instance.
 * @param {String} hugggId - The ID of the Huggg.
 * @param {String} email - The recipient's email.
 */
function sendHugggQREmail(axios, hugggId, email) {
  return axios.post(urls.api("/v3/huggg-deliveries/qr"), {
    hugggId: hugggId,
    email: email
  }).then(prop('data'));
}

/**
 * `single(id, [embed])` makes a request for a single, specific huggg by ID. If
 * embed is not specified defaults will be used to return a full result. *
 *
 * `stash(shortocde, [phoneNumber], [allowSelfClaim])` makes a request to stash
 * a huggg on behalf of a user. If the user is logged in then no phone number
 * need be provided. The huggg will be stashed for the user. If it is a client
 * stashing the huggg then a phone number must be provided to link the huggg to.
 * If the huggg has already been stashed by a different user account, this
 * request will fail. AllowSelfClaim is provided to prevent users accidentally
 * stashing their own hugggs. There is no technical reason not to huggg
 * yourself, so the client app needs to decide if it is likely to be intentional
 * on behalf of the user, or accidental and call appropriately.
 *
 * `redeem(id, code)` redeems a huggg identified by `id` at the location
 * identified by the provided `code`. Returns a redemption object.
 *
 * ---
 *
 * NOTE: A "full result" may vary depending on the client applications level of
 * permission, and the currently logged in users level of permission.
 *
 * NOTE: The 1st param in both method sigs are `axios`. This should typically be
 * disregarded, the withAxios helper will inject that into the first position if
 * not provided.
 */
export default {
  allBySuperhugggId: withAxios(allBySuperhugggId),
  allByTransactionId: withAxios(allByTransactionId),
  bulkOrder: withAxios(bulkOrder, {
    useBackoff: false
  }),
  createTestHuggg: withAxios(createTestHuggg),
  fetch: withAxios(fetch),
  redeem: withAxios(redeem),
  sendTestHuggg: withAxios(sendTestHuggg),
  single: withAxios(single),
  stash: withAxios(stash),
  testHuggg: withAxios(testHuggg),
  toggleSent: withAxios(toggleSent),
  update: withAxios(update),
  updateTestHuggg: withAxios(updateTestHuggg),
  cancel: withAxios(cancel),
  sendHugggQREmail: withAxios(sendHugggQREmail)
};